// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"c1a6c0dc","20":"6427434a","317":"05674085","326":"251724ad","488":"643b8125","605":"fd642ee2","640":"e67aa2d1","708":"9d2cb2b5","778":"4e1e0ed5","780":"7f74ce92","907":"0e9531ad","956":"7e1da995"}[chunkId] + ".chunk.js";
};